import { TargetFormSchema } from './target-form.schema';
import { MessagingCampaignTargetFormInitialValues } from './target-form.types';

export const validateTargetSync = (values: MessagingCampaignTargetFormInitialValues) =>
  TargetFormSchema.safeParse(values);
